
export default {
  data() {
    return {
      appName: 'Income Calculator',
    }
  },

}
